export default {
  methods: {
    apply() {
      this.$emit('apply');
    },
    close() {
      this.$emit('close');
    },
  },
};
